// components/PDFPageFooter.tsx
import { Text, View } from '@react-pdf/renderer'
import moment from 'moment'

import { MeasuresPDFProps } from '../MeasuresPDF'

const styles = {
  footer: {
    position: 'absolute' as const,
    bottom: 20,
    left: 40,
    right: 40,
    fontSize: 10,
    flexDirection: 'row' as const,
    justifyContent: 'space-between' as const,
    borderTopWidth: 1,
    borderTopColor: '#c3c3c3',
    paddingTop: 4,
    color: '#707070',
  },
  left: {
    fontSize: 8,
    maxWidth: '80%',
  },
  right: {
    fontSize: 8,
    color: '#707070',
  },
}

export const MeasuresPDFFooter = ({
  patient,
  measureData,
  question,
}: MeasuresPDFProps) => {
  const formattedBirthdate = patient.birthdate
    ? moment(patient.birthdate).format('MM/DD/YYYY')
    : ''

  const firstName = patient?.firstName
  const lastName = patient?.lastName
  const formName = measureData?.form?.name || ''
  const questionName = question?.text || ''

  const fullText = [
    firstName,
    lastName,
    '-',
    formattedBirthdate,
    '-',
    formName,
    '|',
    questionName,
  ].join(' ')

  return (
    <View fixed style={styles.footer}>
      <Text style={styles.left}>{fullText}</Text>
      <Text
        render={({ pageNumber, totalPages }) =>
          `Page ${pageNumber} of ${totalPages}`
        }
        style={styles.right}
      />
    </View>
  )
}
